import React, { useState, useCallback } from "react";
import { AnimatePresence } from "framer-motion";
import { ProductImageGallery } from "./ProductImageGallery";
import { ProductDetails } from "./ProductDetails";
import { ProductImageModal } from "./ProductImageModal";

const productImages = [
  {
    id: 1,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-1.jpg",
    alt: "ZivBio Testosterone Booster Supplement Front View",
  },
  {
    id: 2,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-2.jpg",
    alt: "ZivBio Testosterone Booster Supplement Ingredients Label",
  },
  {
    id: 3,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-3.jpg",
    alt: "ZivBio Testosterone Booster Supplement Nutrition Facts",
  },
  {
    id: 4,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-4.jpg",
    alt: "ZivBio Testosterone Booster Supplement Benefits Overview",
  },
  {
    id: 5,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-5.jpg",
    alt: "ZivBio Testosterone Booster Supplement Usage Instructions",
  },
  {
    id: 6,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-6.jpg",
    alt: "ZivBio Testosterone Booster Supplement Side View",
  },
  {
    id: 7,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-7.jpg",
    alt: "ZivBio Testosterone Booster Supplement Safety Information",
  },
  {
    id: 8,
    src: "/product-images/ZivBio-Testosterone-Booster-supplement-for-men-8.jpg",
    alt: "ZivBio Testosterone Booster Supplement Package Contents",
  },
];

export const ProductSection = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleThumbnailClick = (image, index) => {
    setSelectedImageIndex(index);
  };

  const handleFullScreenClick = (image) => {
    setFullScreenImage(image);
  };

  const closeFullScreen = useCallback((e) => {
    e.stopPropagation();
    setFullScreenImage(null);
  }, []);

  const navigateImage = (direction) => {
    setSelectedImageIndex((prevIndex) => {
      const newIndex = prevIndex + direction;
      if (newIndex < 0) return productImages.length - 1;
      if (newIndex >= productImages.length) return 0;
      return newIndex;
    });
  };

  React.useEffect(() => {
    if (fullScreenImage) {
      setFullScreenImage(productImages[selectedImageIndex].src);
    }
  }, [selectedImageIndex, fullScreenImage]);

  return (
    <div
      className="container mx-auto px-4 sm:px-6 lg:px-8 my-8 sm:my-12 md:my-16 lg:my-20"
      id="product"
    >
      {" "}
      <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-start">
        <ProductImageGallery
          selectedImage={productImages[selectedImageIndex].src}
          selectedImageIndex={selectedImageIndex}
          productImages={productImages}
          handleThumbnailClick={handleThumbnailClick}
          handleFullScreenClick={handleFullScreenClick}
          navigateImage={navigateImage}
        />
        <ProductDetails />
      </div>
      <AnimatePresence>
        {fullScreenImage && (
          <ProductImageModal
            fullScreenImage={fullScreenImage}
            closeFullScreen={closeFullScreen}
            productImages={productImages}
            currentImageIndex={selectedImageIndex}
            setSelectedImageIndex={setSelectedImageIndex}
          />
        )}
      </AnimatePresence>
    </div>
  );
};
